import styled from 'styled-components'
import { RadioButton, Text } from '@sketch/components'

export const RadioLabel = styled(Text).attrs({
  textStyle: 'copy.tertiary.standard.E',
})`
  padding-bottom: 8px !important; /* stylelint-disable-line declaration-no-important */
`

export const StyledRadioButton = styled(RadioButton)`
  margin-bottom: 12px;
`

export const FormLabel = styled(Text).attrs({
  textStyle: 'copy.tertiary.standard.E',
})`
  padding-bottom: 8px !important; /* stylelint-disable-line declaration-no-important */
  padding-top: 20px;
`
